import React from 'react';
import { ShieldAlert } from 'lucide-react';
import { GPS_CONFIG } from '../../hooks/useNativeGps';

export const GpsSecurityTips = () => {
  return (
    <div className="mt-6 p-4 bg-indigo-50 rounded-lg border border-indigo-200">
      <div className="flex gap-3">
        <ShieldAlert className="w-5 h-5 text-indigo-600 flex-shrink-0 mt-0.5" />
        <div className="text-sm text-indigo-800">
          <p className="font-medium">Keamanan GPS:</p>
          <ul className="mt-1 list-disc list-inside space-y-1 text-indigo-700 text-xs">
            <li>Akurasi GPS maksimal: {GPS_CONFIG.MAX_ACCURACY_METERS} meter</li>
            <li>GPS harus fresh (tidak boleh cache)</li>
            <li>Disarankan menggunakan perangkat mobile</li>
            <li>Lokasi di luar radius akan tercatat</li>
          </ul>
        </div>
      </div>
    </div>
  );
};
